import React, { useState, useLayoutEffect } from 'react';

// Import react-reveal for animation handling
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';

// Import custom styles
import "./HomeHeaderStyles.css";
import LogoAnimation from './LogoAnimation';

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

function HomeHeader() {
    const [width, height] = useWindowSize();

    const [animationComplete, setAnimationComplete] = useState(false);

    const renderInfobox = () => {
        if (width <= 1726) {
            return (
                <Fade delay={800}>
                    <div className="infobox-container">
                        <h1 className='header highlight'>Fast and Caring Support</h1>
                        <p>HUGS is a 501(C)3 non profit organization established in 2018 based in Mason, Michigan.</p>
                        <p>
                            We aim to reduce stress during difficult times by providing assistance to individuals and families.
                        </p>
                        <p>We do this through advocacy, education, and financial support.</p>
                    </div>
                </Fade>
            )
        }

        return (
            <Fade bottom delay={800}>
                <div className="infobox-container">
                    <h1 className='header highlight'>Fast and Caring Support</h1>
                    <p>HUGS is a 501(C)3 non profit organization established in 2018 based in Mason, Michigan.</p>
                    <p>
                        We aim to reduce stress during difficult times by providing assistance to individuals and families.
                    </p>
                    <p>We do this through advocacy, education, and financial support.</p>
                </div>
            </Fade>
        )
    }


    return (
        <>
            <Fade>
                <div className="header-container">
                    <div className='header-flexbox'>
                        <div className='header-flexbox-photos-side'>
                            <img className="hugs-logo-image" src="/images/logos/new-logo-white.png" />
                        </div>

                        <div className='header-flexbox-info-side'>
                            <Fade delay={150}>
    <div className="infobox-container">
                                <h1 className='header highlight'>Hearts Unite to Give Support</h1>
                                <p>Founded in 2018 in Mason, Michigan, HUGS (Hearts Unite to Give Support) is a 501(c)(3) nonprofit committed to helping individuals and families navigate challenging times.</p>
                                <p>
                                    With operations in Michigan and Nevada and a headquarters in Battle Creek, MI, we host programs and events nationwide to bring support where it's needed most.
                                </p>
                                <p>We aim to reduce stress during difficult times by providing assistance through advocacy, education, and financial support. </p>
                                <p>We hope you'll join us in our mission to make the world a more united place!</p>
                            </div>
                            </Fade>
                        
                            <div className='homepage-header-buttons-container'>
                                <Fade delay={200}>
                                    <a href='/about' className={'involvement-button approved-button'}>
                                        Learn More
                                    </a>
                                </Fade>

                                <Fade delay={250}>
                                    <a href='/events' className={'involvement-button approved-button'}>
                                        Our Events
                                    </a>
                                </Fade>

                                <Fade delay={300}>
                                    <a href='/donate' className={'involvement-button approved-button'}>
                                        Donate
                                    </a>
                                </Fade>

                                <Fade delay={350}>

                                    <a href='/contact' className={'involvement-button approved-button'}>
                                        Contact Us
                                    </a>
                                </Fade>

                            </div>
                        </div>

                    </div>

                    {/* <div className='homepage-header-photos-container'>
                        <img className='homepage-header-event-photo' src={'/images/home/homepage-event-photos/homepage-photo-1.jpeg'} />
                        <img className='homepage-header-event-photo homepage-header-event-photo-wide' src={'/images/home/homepage-event-photos/homepage-photo-4.jpeg'} />
                        <img className='homepage-header-event-photo' src={'/images/home/homepage-event-photos/homepage-photo-2.jpg'} />
                        <img className='homepage-header-event-photo homepage-header-event-photo-wide' src={'/images/home/homepage-event-photos/homepage-photo-3.jpeg'} />

                    </div> */}
                </div>
            </Fade>

        </>
    )
}

export default HomeHeader;